import { Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

interface IReadOnlyFieldProps {
  label: string;
  value: string;
  suffix?: string;
  testId?: string;
}

export const ReadOnlyField = ({ label, value, suffix, testId }: IReadOnlyFieldProps) => (
  <Column data-testid={testId} data-cy={testId} gap={2}>
    <Row align="center" style={{ gap: 6 }}>
      <Typography as="span" bold size="body_large" color={colors.neutral[600]}>
        {label}
      </Typography>
      {suffix && <Typography as="span" color={colors.neutral[500]}>{suffix}</Typography>}
    </Row>
    <Row
      align="center"
      style={{
        height: 40,
        borderRadius: 10,
        backgroundColor: colors.neutral[50],
        paddingLeft: 14,
        paddingRight: 14,
        boxShadow: 'inset 0px 2px 4px rgba(0,0,0,0.25)',
      }}
    >
      <Typography as="span" size="body_large" color={colors.neutral[400]} style={{ flex: 1 }}>
        {value}
      </Typography>
    </Row>
  </Column>
);
